var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2884 21.2499L20.9038 29.8653C21.1516 30.1131 21.274 30.4031 21.2709 30.7353C21.2676 31.0676 21.1368 31.363 20.8784 31.6216C20.6198 31.863 20.327 31.988 20.0001 31.9966C19.6731 32.0052 19.3804 31.8802 19.1218 31.6216L8.55467 21.0545C8.39856 20.8984 8.28856 20.7338 8.22467 20.5608C8.1605 20.3877 8.12842 20.2008 8.12842 19.9999C8.12842 19.7991 8.1605 19.6122 8.22467 19.4391C8.28856 19.266 8.39856 19.1015 8.55467 18.9453L19.1218 8.37826C19.3526 8.14743 19.6384 8.02937 19.9793 8.0241C20.3201 8.01882 20.6198 8.13687 20.8784 8.37826C21.1368 8.63687 21.2659 8.93382 21.2659 9.2691C21.2659 9.60465 21.1368 9.90173 20.8784 10.1603L12.2884 18.7499H31.2501C31.6048 18.7499 31.9018 18.8696 32.1409 19.1091C32.3804 19.3483 32.5001 19.6452 32.5001 19.9999C32.5001 20.3547 32.3804 20.6516 32.1409 20.8908C31.9018 21.1302 31.6048 21.2499 31.2501 21.2499H12.2884Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.a8aeb15df2e86b8be0086b8ae897ad97.svg";
export { ForwardRef as ReactComponent };